import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import RoleShell, { money } from "@/roleapps/RoleShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PIPELINE = ["sales_order", "confirmed", "in_production", "ready", "delivered"];
const LABELS = { sales_order: "Sales order", confirmed: "Confirmed", in_production: "In production", ready: "Ready to ship", delivered: "Delivered" };
const NEXT = { sales_order: "confirmed", confirmed: "in_production", in_production: "ready", ready: "delivered", delivered: null };

export default function ManufacturerApp() {
  const [orders, setOrders] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState("");

  const load = useCallback(() => {
    axios.get(`${API}/orders`).then((r) => setOrders(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Load failed"));
  }, []);
  useEffect(load, [load]);

  const advance = async (o) => {
    const to = NEXT[o.status];
    if (!to) return;
    setBusy(o.id); setErr("");
    try { await axios.patch(`${API}/orders/${o.id}/status`, { status: to }); load(); }
    catch (e) { setErr(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Could not advance"); }
    finally { setBusy(""); }
  };

  const byStatus = (s) => (orders || []).filter((o) => o.status === s);

  return (
    <RoleShell mark="MF" title="Manufacturer" subtitle="Production pipeline" testid="manufacturer-app">
      <h1 className="ra-h1">Production board</h1>
      <p className="ra-h1sub">Orders routed to your factory. Advance each through the production pipeline.</p>
      {err && <div className="ra-msg err">{err}</div>}
      {!orders ? <div className="ra-empty">Loading…</div> : orders.length === 0 ? (
        <div className="ra-card ra-empty">No orders yet. Orders appear here when a dealer converts an approved quote.</div>
      ) : (
        <div className="ra-board" data-testid="production-board">
          {PIPELINE.map((s) => (
            <div className="ra-col" key={s} data-testid={`col-${s}`}>
              <div className="ra-col-h"><span>{LABELS[s]}</span><span>{byStatus(s).length}</span></div>
              {byStatus(s).map((o) => (
                <div className="ra-ocard" key={o.id} data-testid={`order-${o.id}`}>
                  <h4>{o.number}</h4>
                  <div className="meta">{(o.production?.parts?.length ?? o.production?.part_count ?? "—")} parts</div>
                  <div className="total">{money(o.total)}</div>
                  {NEXT[o.status] && (
                    <button className="ra-advance" disabled={busy === o.id} onClick={() => advance(o)} data-testid={`advance-${o.id}`}>
                      {busy === o.id ? "…" : `→ ${LABELS[NEXT[o.status]]}`}
                    </button>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </RoleShell>
  );
}
